
/*
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors  : Nie Wie
 * @LastEditTime : 2021-04-12 09:42:58
 * @Description: 入口
 */
import 'normalize.css'

import Vue from 'vue'
import router from '@/router/index'

import '@/assets/styles/common.scss'
import 'swiper/dist/css/swiper.css'

import '@/assets/js/install-lodash.js'

import resizeMixin from '@/mixin/resizeMixin'

import pageEvent from '@/assets/js/page-event'
import Antd from '@/assets/js/install-antd-ui'
import echarts from '@/assets/js/install-echarts'
import server from '@/assets/js/install-axios'

import App from './App.vue'
import store from './store'

Vue.use(Antd)
Vue.use(echarts)
Vue.use(server) // 修改为network

Vue.mixin(resizeMixin)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  created() {
    pageEvent.init()
  },
  beforeDestroy() {
    pageEvent.destroy()
  },
  render: h => h(App),
}).$mount('#app')
